
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  border-radius: 0.5rem;
  display:inline-block;
  box-sizing:border-box;
  position:relative;
  max-height:100%;
  width:100%;
}

.link {
  position: relative;
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: grid;
  height: 100%;
  width: 100%;
  cursor: pointer;
  align-items: center;
  border-radius: 0.5rem;
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
  pointer-events:all;
}

.nolink{
  cursor:default !important;
}

.nolink .link{
    cursor:default;
  }

.gradient-background {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 10;
  height: 100%;
  width: 100%;
  border-radius: 0.5rem;
  background:rgb(176, 207, 184);
  background:linear-gradient(
    356deg,
    rgba(176, 207, 184, 1) 24%,
    rgba(48, 129, 68, 1) 100%
  );
}

.gray-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 10;
  height: 100%;
  width: 100%;
  border-radius: 0.5rem;
  background-color:rgba(0, 0, 0, 0.5);
}

img {
  position: absolute;
  border-radius: 0.5rem;
  object-fit: cover;
  height:100% !important;
  width:100% !important;
}

.text-wrapper {
  position: relative;
  z-index: 10;
  margin: 2rem;
  border-radius: 0.5rem;
  padding: 2rem;
  text-align: left;
  color: var(--neutral-white);
  word-break:break-word;
}

.heading a {
  color: var(--neutral-white);
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

.description {
  position: relative;
  margin-top: 1rem;
}

@media (min-width: 1024px) {

  .description {
    display: none;
  }
}

.description__trigger {
  display: block;
}

.description__trigger .description {
  position: absolute;
}

.description__trigger .description {
  display: block;
}

.description__trigger .description {
  padding-right: 3rem;
}

.text-wrapper.wrapper-mobile {
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  justify-content: center;
  opacity: 0.9;
}

.text-wrapper.wrapper-mobile .number {
  display: none;
}

.link:hover .text-wrapper, .link:active .text-wrapper, .link:focus .text-wrapper, .link:hover .text-wrapper--open {
  position: relative;
  z-index: 10;
  margin: 2rem;
  border-radius: 0.5rem;
  background-color: var(--green-guarantee-darken-2);
  opacity: 0.9;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@media (hover: none) and (pointer: coarse){
  .text-wrapper--open .description {
    background-color: var(--green-guarantee-darken-2);
  }
  .text-wrapper--open .description {
    color: var(--neutral-white);
  }
  .text-wrapper--open .description {
    opacity: 0.9;
  }
  .text-wrapper--open .description{
    z-index:6;
  }
}

.text-wrapper--open .description {
  border-radius: 0.5rem;
  text-align: left;
  color: var(--neutral-white);
  opacity:1 !important;
  pointer-events:all;
  z-index:6;
}

.number {
  position: absolute;
  z-index: 20;
  float: right;
  transform-origin: bottom right;
  bottom:-6px;
  right:16px;
}

:host .link:hover .text-wrapper, :host .link:active .text-wrapper, :host .link:focus .text-wrapper, :host .link:hover .text-wrapper--open {
  opacity: 0.9;
}

.hover-color--red .link:hover .text-wrapper--open, .hover-color--red .link:hover .text-wrapper, .hover-color--red .link:active .text-wrapper, .hover-color--red .link:focus .text-wrapper {
  background-color: var(--idblab-magenta-main);
}

.hover-color--dark-blue .link:hover .text-wrapper--open, .hover-color--dark-blue .link:hover .text-wrapper, .hover-color--dark-blue .link:active .text-wrapper, .hover-color--dark-blue .link:focus .text-wrapper {
  background-color: var(--blue-responsible-darken-2);
}

.hover-color--green .link:hover .text-wrapper--open, .hover-color--green .link:hover .text-wrapper, .hover-color--green .link:active .text-wrapper, .hover-color--green .link:focus .text-wrapper {
  background-color: var(--idblab-green-main);
}

.hover-color--yellow .link:hover .text-wrapper--open, .hover-color--yellow .link:hover .text-wrapper, .hover-color--yellow .link:active .text-wrapper, .hover-color--yellow .link:focus .text-wrapper {
  background-color: var(--idblab-yellow-main);
}

.hover-color--blue .link:hover .text-wrapper--open, .hover-color--blue .link:hover .text-wrapper, .hover-color--blue .link:active .text-wrapper, .hover-color--blue .link:focus .text-wrapper {
  background-color: var(--blue-responsible-main);
}

.hover-color--black .link:hover .text-wrapper--open,
.hover-color--black .link:hover .text-wrapper,
.hover-color--black .link:active .text-wrapper,
.hover-color--black .link:focus .text-wrapper{
  background-color:#0b0b0b;
}

.hover-color--purple .link:hover .text-wrapper--open, .hover-color--purple .link:hover .text-wrapper, .hover-color--purple .link:active .text-wrapper, .hover-color--purple .link:focus .text-wrapper {
  background-color: var(--purple-new-darken-2);
}

.hover-color--light-blue .link:hover .text-wrapper--open, .hover-color--light-blue .link:hover .text-wrapper, .hover-color--light-blue .link:active .text-wrapper, .hover-color--light-blue .link:focus .text-wrapper {
  background-color: var(--cyan-near-darken-2);
}

:host([number='number-1']) .text-wrapper {
  min-height: 363px;
}

:host([number='number-1']) .text-wrapper.wrapper-mobile {
  min-height: 150px;
}

:host([number='number-2']) .text-wrapper {
  min-height: 752px;
}

:host([number='number-2']) .text-wrapper.wrapper-mobile {
  min-height: 150px;
  opacity: 0.9;
}

:host([number='number-3']) .text-wrapper {
  min-height: 432px;
}

:host([number='number-3']) .text-wrapper.wrapper-mobile {
  min-height: 150px;
  opacity: 0.9;
}

:host([number='number-4']) .text-wrapper {
  min-height: 363px;
}

:host([number='number-4']) .text-wrapper.wrapper-mobile {
  min-height: 150px;
  opacity: 0.9;
}

:host([number='number-5']) .text-wrapper {
  min-height: 432px;
}

:host([number='number-5']) .text-wrapper.wrapper-mobile {
  min-height: 150px;
}
`;